import VolieState from '@/store';

interface Tab {
    name: string;
    icon?: string;
    key: string;
    href: string;
    valid?: boolean;
}

export const USER_SUPER_ADMIN_ROLE_ID = 1;
export const USER_MANAGER_ROLE_ID = 2;
export const USER_AGENT_ROLE_ID = 3;
export const USER_OWNER_ROLE_ID = 4;
export const USER_SUPERVISOR_ROLE_ID = 5;
export const USER_ORGANIZATION_MANAGER_ROLE_ID = 8;
export const USER_ORGANIZATION_AGENT_ROLE_ID = 9;
export const USER_CLIENT_EMPLOYEE_ROLE_ID = 6;

export function getUserBuilderTabs(isSuperAdmin: boolean): Tab[] {
    const userDevicesEnabled = import.meta.env.VITE_USER_DEVICES_ENABLED === '1';

    let userTabs: Tab[] = [
        { name: "Organizations", key: "organizations", href: "#organizations", icon: "mdi-office-building", valid: true },
        { name: "Call Queues", key: "call_queues", href: "#call-queues", icon: "mdi-phone", valid: true },
        { name: "Employees", key: "employees", href: "#employees", icon: "mdi-account-group", valid: true },
        { name: "Advanced Settings", key: "advanced_options", href: "#advanced-options", icon: "mdi-cog", valid: true },
        { name: "Custom Fields", key: "custom_fields", href: "#custom-fields", icon: "mdi-playlist-edit", valid: true },
        { name: "Forte CRM Key", key: "forte_crm_key", href: "#forte-crm-key", icon: "mdi-key", valid: true },
        { name: "System Alerts", key: "system_alerts", href: "#system-alerts", icon: "mdi-information", valid: true },
        // { name: "Security Settings", key: "security_settings", href: "#security-settings", icon: "mdi-lock", valid: true },
    ];

    if (userDevicesEnabled) {
        userTabs.push({ name: "User Devices", key: "user_devices", href: "#user-devices", icon: "mdi-cellphone", valid: true });
    }

    if (!isSuperAdmin) {
        userTabs = userTabs.filter(x => x.key !== 'forte_crm_key');
    }

    const sortedUserTabs: Tab[] = userTabs.sort((a, b) => {
        if (a.name < b.name) {
            return -1;
        }
        if (a.name > b.name) {
            return 1;
        }
        return 0;
    });

    return sortedUserTabs;
}

export function getUserRoles() {
    const outgoing = [
        { role_id: 3, role_name: 'Agent',                           group: 'Account',       },
        { role_id: 2, role_name: 'Manager',                         group: 'Account',       },
        { role_id: 4, role_name: 'Owner',                           group: 'Account',       },
        { role_id: 5, role_name: 'Supervisor',                      group: 'Account',       },
        { role_id: 8, role_name: 'Organization Manager',            group: 'Organization',  },
        { role_id: 6, role_name: 'Organization Client Employee',    group: 'Organization',  },
        { role_id: 9, role_name: 'Organization Agent',              group: 'Organization',  },
    ];

    if (VolieState?.currentUser()?.activated_role_id === 1) {
        outgoing.unshift({ role_id: 1, role_name: 'Super Admin', group: 'Account', });
    }

    return outgoing;
}

export function getUserDefaultRoleName(default_role_id) {
    switch (default_role_id || -1) {
        case 3:
            return 'Agent';
        case 2:
            return 'Manager';
        case 4:
            return 'Owner';
        case 1:
            return 'Super Admin';
        case 5:
            return 'Supervisor';
        case 8:
            return 'Organization Manager';
        case 9:
            return 'Organization Agent';
        case 6:
            return 'Client Employee';
        default:
            return '---'
    }
}

export function currentUserIsManagerOrAdmin() {
    switch (VolieState?.currentUser()?.activated_role_id) {
        case USER_MANAGER_ROLE_ID:
            return true;
        case USER_SUPER_ADMIN_ROLE_ID:
            return true;
        case USER_ORGANIZATION_MANAGER_ROLE_ID:
            return true;
        case USER_OWNER_ROLE_ID:
            return true;
        default:
            return false;
    }
}